/**
 * @generated SignedSource<<8cfcd893493a9ed89534355d12fee1ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbLeadTime_item$data = {
  readonly itemType: string | null;
  readonly isNewAndMadeToOrder: boolean | null;
  readonly isListingUnlisted: boolean | null;
  readonly attributes: {
    readonly leadTime: ReadonlyArray<{
      readonly option: {
        readonly name: string | null;
        readonly urlLabel: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PdpSharedBlurbLeadTime_item";
};
export type PdpSharedBlurbLeadTime_item$key = {
  readonly " $data"?: PdpSharedBlurbLeadTime_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBlurbLeadTime_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbLeadTime_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNewAndMadeToOrder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingUnlisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "leadTime",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AttributeOption",
              "kind": "LinkedField",
              "name": "option",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlLabel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "d14bd34d9f6deea336ec0c9b3b27f553";

export default node;
